var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.valid === false)?_c('div',{staticClass:"alert alert-soft-danger"},[_c('i',{staticClass:"fas fa-info-circle mt-1 mr-1"}),_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }